import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SessionSettingsTab = ({ sessionData, onUpdateSettings }) => {
  const [capacity, setCapacity] = useState(sessionData?.capacity);
  const [memberPrice, setMemberPrice] = useState(sessionData?.pricing?.member);
  const [guestPrice, setGuestPrice] = useState(sessionData?.pricing?.guest);
  const [registrationDeadline, setRegistrationDeadline] = useState(sessionData?.registrationDeadline);
  const [paymentDeadline, setPaymentDeadline] = useState(sessionData?.paymentDeadline);

  useEffect(() => {
    setCapacity(sessionData?.capacity);
    setMemberPrice(sessionData?.pricing?.member);
    setGuestPrice(sessionData?.pricing?.guest);
    setRegistrationDeadline(sessionData?.registrationDeadline);
    setPaymentDeadline(sessionData?.paymentDeadline);
  }, [sessionData]);

  const pricingModelOptions = [
    { value: 'split', label: 'N/1 분할 (총액을 인원수로 나눔)' },
    { value: 'fixed', label: '고정 금액 (1인당 고정 가격)' },
    { value: 'membership', label: '회원권 차감' },
    { value: 'itemized', label: '항목별 정산' }
  ];

  const handleSaveSettings = async () => {
    const updatedSettings = {
      capacity: parseInt(capacity),
      pricing: {
        member: parseInt(memberPrice),
        guest: parseInt(guestPrice)
      },
      registrationDeadline,
      paymentDeadline
    };

    try {
      await onUpdateSettings(updatedSettings);
      alert('세션 설정이 저장되었습니다.');
    } catch {
      // parent shows error alert
    }
  };

  const handleResetSettings = () => {
    if (window.confirm('설정을 초기값으로 되돌리시겠습니까?')) {
      setCapacity(sessionData?.capacity);
      setMemberPrice(sessionData?.pricing?.member);
      setGuestPrice(sessionData?.pricing?.guest);
      setRegistrationDeadline(sessionData?.registrationDeadline);
      setPaymentDeadline(sessionData?.paymentDeadline);
    }
  };

  return (
    <div className="space-y-6">
      <div className="p-4 md:p-6 bg-card rounded-md border border-border">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4">
          기본 설정
        </h3>

        <div className="space-y-6">
          <Input
            type="number"
            label="정원"
            value={capacity}
            onChange={(e) => setCapacity(e?.target?.value)}
            description="세션에 참가할 수 있는 최대 인원수"
            required
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              type="datetime-local"
              label="등록 마감 시간"
              value={registrationDeadline}
              onChange={(e) => setRegistrationDeadline(e?.target?.value)}
              description="참가 신청을 받는 마지막 시간"
              required
            />

            <Input
              type="datetime-local"
              label="결제 마감 시간"
              value={paymentDeadline}
              onChange={(e) => setPaymentDeadline(e?.target?.value)}
              description="참가비 입금 마감 시간"
              required
            />
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6 bg-card rounded-md border border-border">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4">
          가격 설정
        </h3>

        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              type="number"
              label="회원 가격"
              value={memberPrice}
              onChange={(e) => setMemberPrice(e?.target?.value)}
              description="등록된 회원의 1인당 참가비"
              required
            />

            <Input
              type="number"
              label="게스트 가격"
              value={guestPrice}
              onChange={(e) => setGuestPrice(e?.target?.value)}
              description="비회원(게스트)의 1인당 참가비"
              required
            />
          </div>

          <div className="p-4 bg-muted rounded-md">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={16} className="text-muted-foreground mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">가격 정책 안내</p>
                <p className="text-sm caption text-muted-foreground">
                  회원과 게스트의 가격을 다르게 설정할 수 있습니다.\n
                  게스트 참가를 허용하지 않으려면 아래 옵션을 해제하세요.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-3">
        <Button
          variant="default"
          size="default"
          iconName="Save"
          iconPosition="left"
          onClick={handleSaveSettings}
          fullWidth
        >
          설정 저장
        </Button>

        <Button
          variant="outline"
          size="default"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={handleResetSettings}
          fullWidth
        >
          초기화
        </Button>
      </div>
    </div>
  );
};

export default SessionSettingsTab;